import { create, useStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface AceCardState {
  expanded: boolean;
  actions: {
    toggleExpanded: () => void;
  };
}

const createAceCardStore = (id: string, isExpandedByDefault: boolean) =>
  create<AceCardState>()(
    persist(
      (set) => ({
        expanded: isExpandedByDefault,
        actions: {
          toggleExpanded: () => set((state) => ({ expanded: !state.expanded })),
        },
      }),
      {
        name: `AceCardState.${id}`,
        partialize: ({ actions: _, ...state }) => state,
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  );

const aceCardStores: Record<string, ReturnType<typeof createAceCardStore>> = {};

function getAceCardStore(id: string, isExpandedByDefault: boolean) {
  if (!aceCardStores[id])
    aceCardStores[id] = createAceCardStore(id, isExpandedByDefault);

  return aceCardStores[id];
}

export function useAceCardStore(id: string, isExpandedByDefault: boolean) {
  return useStore(getAceCardStore(id, isExpandedByDefault));
}
